export interface ExpiryReport {
  productID: number;
  productName: string;
  optionValueID?: string;
  optionName?: string;
  sku: string | null;
  barcode: string | null;
  quantity: number;
  inStock: boolean;
  isActive: boolean;
  expiryDate: string | null;
}

export interface ExpiryReportResponse {
  product_id: number;
  product_name: string;
  option_value_id?: string;
  option_name?: string;
  sku: string | null;
  barcode: string | null;
  quantity: number;
  in_stock: boolean;
  is_active: boolean;
  expiry_date: string | null;
}

export const expiryReportFromResponse = (
  responseData: ExpiryReportResponse,
): ExpiryReport => ({
  productID: responseData.product_id,
  productName: responseData.product_name,
  optionValueID: responseData.option_value_id,
  optionName: responseData.option_name,
  sku: responseData.sku,
  barcode: responseData.barcode,
  quantity: responseData.quantity,
  inStock: responseData.in_stock,
  isActive: responseData.is_active,
  expiryDate: responseData.expiry_date,
});
